// extracted by mini-css-extract-plugin
module.exports = {"toggler":"AdminForm_toggler_2axaU","form-item--last":"AdminForm_form-item--last_3wSqX","footer":"AdminForm_footer_2IHy2"};